import React, { FC } from 'react'

import Box, { BoxProps } from '@material-ui/core/Box'

const SearchToolBox: FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      height={40}
      mb={3}
      alignItems="center"
      {...props}
    >
      {children}
    </Box>
  )
}

export default SearchToolBox
